import { api } from './api';

// Define a service using a base URL and expected endpoints
export const usagesApi = api.injectEndpoints({
  reducerPath: 'usagesApi',
  tagTypes: ['Usages'],
  endpoints: (builder) => ({
    getUsages: builder.query({
      query: ({ start, end }) => ({
        url: `/api/administration/usages`,
        method: 'POST',
        body: { start, end }
      }),
      keepUnusedDataFor: 0
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUsagesQuery } = usagesApi;
